export default "__VITE_ASSET__Cs6OZT$E__"